import SegmentIO from 'reporting/SegmentIO';

export type BreakdownAnalyticsActionType = 'expanded' | 'collapsed';

export const sendBreakdownButtonClickedEvent = (
  action: BreakdownAnalyticsActionType,
  lineItemsCount: number,
  isMobile: boolean
) => {
  SegmentIO.contentEngaged({
    object: 'content',
    action: 'engaged',
    ui_object: 'button',
    ui_object_detail: 'invoice_breakdown_button',
    ui_action: 'clicked',
    ui_access_point: 'transaction_flow',
    breakdown_action: action,
    line_items_count: lineItemsCount,
    is_mobile_device: isMobile,
  });
};
